// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3_jDt","title":"InfoRow_title__Xk1wZ"};